import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { createElementBlock as t, createElementVNode as n, createTextVNode as r, openBlock as i, toDisplayString as a } from "vue";
//#region components/codeblock/codeblock.vue
var o = {
	compatConfig: { MODE: 3 },
	name: "DtCodeblock",
	props: { text: {
		type: String,
		required: !0
	} }
}, s = { class: "d-codeblock" };
function c(e, o, c, l, u, d) {
	return i(), t("pre", null, [
		o[0] || (o[0] = r("    ", -1)),
		n("code", s, a(c.text), 1),
		o[1] || (o[1] = r("\n  ", -1))
	]);
}
var l = /* @__PURE__ */ e(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=codeblock.js.map